"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_service_1 = require("src/app/Services/service.service");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var material_1 = require("@angular/material");
var DialogLoginComponent = /** @class */ (function () {
    function DialogLoginComponent(fb, dialogRef, data, service) {
        this.fb = fb;
        this.dialogRef = dialogRef;
        this.data = data;
        this.service = service;
        this.loginForm = this.fb.group({
            email: [null, forms_1.Validators.required],
            password: [null, forms_1.Validators.required],
            rememberme: [true]
        });
        this.additionalLoginTitle = undefined;
        this._showPassword = false;
        this._captchaResolvedFlag = false;
        if (this.dialogRef) {
            this.dialogRef.addPanelClass("login-dialog-backdrop");
        }
        if (this.data && this.data.email && this.data.email != 'undefined') {
            this.loginForm.controls["email"].setValue(this.data.email);
        }
        if (this.data && this.data.password) {
            this.loginForm.controls["password"].setValue(this.data.password);
        }
        if (this.data && this.data.rememberme) {
            this.loginForm.controls["rememberme"].setValue(this.data.rememberme);
        }
        if (this.data && this.data.additionalLoginTitle) {
            this.additionalLoginTitle = this.data.additionalLoginTitle;
        }
    }
    Object.defineProperty(DialogLoginComponent.prototype, "showPassword", {
        get: function () {
            return this._showPassword;
        },
        set: function (value) {
            this._showPassword = value;
        },
        enumerable: true,
        configurable: true
    });
    DialogLoginComponent.prototype.ngOnInit = function () {
    };
    DialogLoginComponent.prototype.getCaptchaResolvedFlag = function () {
        return this._captchaResolvedFlag;
    };
    DialogLoginComponent.prototype.setCaptchaResolvedFlag = function (value) {
        this._captchaResolvedFlag = value;
    };
    DialogLoginComponent.prototype.captchaResolved = function (captchaResponse) {
        this.setCaptchaResolvedFlag(true);
    };
    DialogLoginComponent.prototype.captchaAvailable = function () {
        return this.service.captchaService.getCurrentCaptchaKey() != "";
    };
    DialogLoginComponent.prototype.isCaptchaOk = function () {
        return true;
        return this.captchaAvailable() && this._captchaResolvedFlag;
    };
    DialogLoginComponent.prototype.closeAction = function () {
        this.dialogRef.close();
    };
    DialogLoginComponent.prototype.validateAllFormFields = function (formGroup) {
        var _this = this;
        Object.keys(formGroup.controls).forEach(function (field) {
            var control = formGroup.get(field); //{3}
            if (control instanceof forms_1.FormControl) { //{4}
                control.markAsTouched({ onlySelf: true });
            }
            else if (control instanceof forms_1.FormGroup) { //{5}
                _this.validateAllFormFields(control); //{6}
            }
        });
    };
    DialogLoginComponent.prototype.onSubmit = function () {
        this.validateAllFormFields(this.loginForm);
        if (!this.loginForm.invalid) {
            if (!this.isCaptchaOk()) {
                this.service.showError("Please confirm the captcha");
            }
            else {
                this.dialogRef.close({
                    email: this.loginForm.controls["email"].value,
                    password: this.loginForm.controls["password"].value,
                    rememberme: this.loginForm.controls["rememberme"].value
                });
            }
        }
    };
    DialogLoginComponent.prototype.keyEventUp = function (event) {
        if (event.keyCode === 13) {
            this.onSubmit();
        }
    };
    return DialogLoginComponent;
}());
exports.DialogLoginComponent = DialogLoginComponent;
